/* eslint-disable key-spacing */
export const defaultTheme = {
  buttonDisabled:         'disabled-button',
  dateCell:               'calendar-date-cell',
  dateCellActive:         'active',
  dateCellDayOff:         'day-off',
  dateCellDifferentMonth: 'different-month-date',
  dateCellDisabled:       'disabled-date',
  dateCellMarked:         'marked-date',
  dateCellSelected:       'selected',
  dateCellToday:          'today',
  dateRow:                'calendar-dates-row',
  dateView:               'calendar-month-dates',
  footer:                 'calendar-footer',
  header:                 'calendar-nav',
  monthCell:              'calendar-month-year-cell',
  monthCellActive:        'active',
  monthCellDisabled:      'disabled-month-year',
  monthRow:               'calendar-month-year-row',
  monthView:              'calendar-month-year-view',
  nextButton:             'calendar-next-button',
  nextIcon:               'calendar-next-icon',
  prevButton:             'calendar-prev-button',
  prevIcon:               'calendar-prev-icon',
  title:                  'calendar-title',
  titleDisabled:          'disabled-title',
  weekDaysRow:            'calendar-week-days',
  wrapper:                'calendar-wrapper',
  wrapperRight:           'pos-right',
  wrapperTop:             'pos-top',
  wrapperVisible:         'visible',
  yearCell:               'calendar-month-year-cell',
  yearCellActive:         'active',
  yearCellDifferentDecade:'different-year',
  yearCellDisabled:       'disabled-month-year',
  yearRow:                'calendar-month-year-row',
  yearView:               'calendar-month-year-view',
};
/* eslint-enable key-spacing */
